<template>
    <div class="container step step1">
        <div class="card-container">
            <a href="#" class="question" @click.prevent="pageChange = !pageChange">
                <img src="../../assets/step4/page4_question.png" v-if="pageChange == false" alt="">
                <img src="../../assets/step4/page4_question_change.png" v-if="pageChange" alt="">
            </a>
            <img src="../../assets/step4/page4_card.png" class="card" alt="">
            <img src="../../assets/step4/page4_people.png" class="people" alt="">
        </div><!-- card container end sub -->
        <img src="../../assets/step4/page4_bg.jpg" class="bg" alt="">
        <template>
            <router-link to="/step3-2" class="btn-prev el-icon-arrow-left"></router-link>
            <router-link to="/step4-1" class="btn-next el-icon-arrow-right"></router-link>
        </template>
    </div>
</template>

<script>
export default {
  name: 'step1',
  data () {
    return {
      pageChange: false
    }
  }
}
</script>

<style scoped>
    .btn-prev {
        color:#b7798e;
    }
    .btn-next {
        background:#b7798e;color:white;
    }
</style>



// WEBPACK FOOTER //
// src/components/step4/index.vue